import { getOptionsGlobal } from 'actions/global';
import BWAccordion from 'components/shared/BWAccordion';
import FormDatePicker from 'components/shared/BWFormControl/FormDate';
import FormInput from 'components/shared/BWFormControl/FormInput';
import FormItem from 'components/shared/BWFormControl/FormItem';
import FormNumber from 'components/shared/BWFormControl/FormNumber';
import FormSelect from 'components/shared/BWFormControl/FormSelect';
import FormTextArea from 'components/shared/BWFormControl/FormTextArea';
import { EmploymentTypeOpts } from 'pages/Recruitment/helper/constants';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mapDataOptions4Select } from 'utils/helpers';

const RecruitmentInfo = ({ disabled, title }) => {
  const dispatch = useDispatch();
  const { businessData, positionData, departmentData } = useSelector((state) => state.global);

  // load options
  const getOptions1Time = useCallback(() => {
    dispatch(getOptionsGlobal('business'));
    dispatch(getOptionsGlobal('position'));
    dispatch(getOptionsGlobal('department'));
  }, [dispatch]);
  useEffect(getOptions1Time, [getOptions1Time]);

  return (
    <BWAccordion title={title}>
      <div className='bw_row'>
        <div className='bw_col_6'>
          <FormItem label='Tiêu đề tuyển dụng' isRequired disabled={disabled}>
            <FormInput
              field='recruitment_name'
              placeholder='Nhập tiêu đề tuyển dụng'
              validation={{
                required: 'Tiêu đề tuyển dụng là bắt buộc',
              }}
            />
          </FormItem>
        </div>

        <div className='bw_col_6'>
          <FormItem label='Số lượng tuyển dụng' isRequired disabled={disabled}>
            <FormNumber
              field='quantity'
              disabled={disabled}
              validation={{
                required: 'Số lượng tuyển dụng là bắt buộc',
              }}
            />
          </FormItem>
        </div>

        <div className='bw_col_6'>
          <FormItem label='Xưởng/Chi nhánh' isRequired disabled={disabled}>
            <FormSelect
              field='business_id'
              list={mapDataOptions4Select(businessData)}
              validation={{ required: 'Xưởng/Chi nhánh là bắt buộc' }}
            />
          </FormItem>
        </div>

        <div className='bw_col_6'>
          <FormItem label='Phòng ban, chuyên khoa' isRequired disabled={disabled}>
            <FormSelect
              field='department_id'
              list={mapDataOptions4Select(departmentData)}
              validation={{ required: 'Phòng ban, chuyên khoa là bắt buộc' }}
            />
          </FormItem>
        </div>

        <div className='bw_col_6'>
          <FormItem label='Vị trí tuyển dụng' isRequired disabled={disabled}>
            <FormSelect
              field='position_id'
              list={mapDataOptions4Select(positionData)}
              validation={{ required: 'Vị trí tuyển dụng là bắt buộc' }}
            />
          </FormItem>
        </div>

        <div className='bw_col_6'>
          <FormItem label='Ngày đăng' disabled={disabled}>
            <FormDatePicker
              field={'posted_date'}
              placeholder={'dd/mm/yyyy'}
              style={{ width: '100%' }}
              format='DD/MM/YYYY'
              bordered={false}
            />
          </FormItem>
        </div>

        <div className='bw_col_6'>
          <FormItem label='Ngày hết hạn' isRequired disabled={disabled}>
            <FormDatePicker
              field={'expired_date'}
              placeholder={'dd/mm/yyyy'}
              style={{ width: '100%' }}
              format='DD/MM/YYYY'
              bordered={false}
              validation={{
                required: 'Ngày hết hạn là bắt buộc',
              }}
            />
          </FormItem>
        </div>

        <div className='bw_col_6'>
          <FormItem label='Hình thức làm việc' isRequired disabled={disabled}>
            <FormSelect
              field='employment_type'
              placeholder='--Chọn--'
              list={EmploymentTypeOpts}
              validation={{
                required: 'Hình thức làm việc là bắt buộc',
              }}
            />
          </FormItem>
        </div>

        <div className='bw_col_6'>
          <FormItem label='Mức lương' isRequired disabled={disabled}>
            <FormTextArea
              field='salary'
              disabled={disabled}
              validation={{
                required: 'Mức lương là bắt buộc',
              }}
              // addonAfter='VNĐ'
            />
          </FormItem>
        </div>

        <div className='bw_col_12'>
          <FormItem disabled={disabled} label='Giới thiệu'>
            <FormTextArea type='text' field='introduction' placeholder='' />
          </FormItem>
        </div>
      </div>
    </BWAccordion>
  );
};

export default RecruitmentInfo;
